"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Inputs({ expression, document, changeExpression, changeXML }) {
    const onExpressionChange = (e) => {
        changeExpression(e.target.value);
    };
    const onXMLChange = (e) => {
        changeXML(e.target.value);
    };
    return react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "field" },
            react_1.default.createElement("label", { className: "label" }, "Enter XPath expression"),
            react_1.default.createElement("div", { className: "control" },
                react_1.default.createElement("input", { className: "input", type: "text", defaultValue: expression, onChange: onExpressionChange }))),
        react_1.default.createElement("div", { className: "field" },
            react_1.default.createElement("label", { className: "label" }, "Paste XML Document contents"),
            react_1.default.createElement("div", { className: "control" },
                react_1.default.createElement("textarea", { className: "textarea", defaultValue: document, onChange: onXMLChange }))));
}
exports.default = Inputs;
